import { ConciergeKnowledgeSchema } from "@redotech/redo-model/concierge-knowledge";
import * as z from "zod/v4";

export const createConciergeKnowledge = {
  name: "createConciergeKnowledge" as const,
  input: z.object({
    title: z.string(),
    knowledge: z.string(),
    expiresAt: z.date().optional(),
    recommendedProductIds: z.array(z.string()).max(5).optional(),
  }),
  output: ConciergeKnowledgeSchema,
};
